module.exports = __webpack_public_path__ + "static/media/Staliupaslaugos.42b1970f.png";